import{mapTableToPropsFactory}from'./table';export default mapTableToPropsFactory('requestTemplates');